import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { environment } from 'src/environments/environment';
import { take, takeUntil } from 'rxjs/operators';
import { ReplaySubject, Subject } from 'rxjs';
import { MatSelect } from '@angular/material/select';

interface incub {
  newsletterId: string;
  incubatorName: string;
}

@Component({
  selector: 'app-newsletters-add',
  templateUrl: './newsletters-add.component.html',
  styleUrls: ['./newsletters-add.component.css'],
})
export class NewslettersAddComponent implements OnInit {
  protected incubatorNameList: incub[] = [];
  uploadedFile: File | null = null;
  selectedFileName: string | null = null;
  public incubatorName: FormControl = new FormControl();
  public incubatorFilterCtrl: FormControl = new FormControl();
  public incubatorListValue = new ReplaySubject(1);
  @ViewChild('singleSelect', { static: true }) singleSelect: MatSelect;
  newslettersForm: FormGroup;
  private saveApi = environment.url + environment.newsletterSave;
  private getApi = environment.url + environment.newsletterGet;
  private nameListApi = environment.url + environment.incubatorNameList;

  datas;
  /**
   * The constructor for the NewslettersAddComponent.
   * @param data The dialog data passed in.
   * @param fb The form builder.
   * @param makeapi The API service.
   * @param notify The notify service.
   * @param dialogRef The dialog reference.
   */
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private notify: NotifyService,
    public dialogRef: MatDialogRef<NewslettersAddComponent>
  ) {
    // Retrieve the dialog data
    this.datas = data;
    // If the dialog title is 'Update', get the newsletter details
    if (data.title == 'Update') {
      this.getNewsletterDetails(data._id);
    }
    // Initialize the form group
    this.newslettersForm = this.fb.group({
      // The newsletter ID
      id: [0],
      // The newsletter title
      title: ['', [Validators.required]],
      // The newsletter file
      newsletterFile: [''],
    });
  }
  get add() {
    return this.newslettersForm.controls;
  }
  roleValue;
  /**
   * Initializes the component, retrieves the user role from session storage,
   * and performs actions based on the user's role.
   */
  ngOnInit(): void {
    // Retrieve the user's role from session storage
    this.roleValue = sessionStorage.getItem('role');

    // Check if the user is not an Admin
    if (this.roleValue !== 'Admin') {
      // Get the current form values
      const getform = this.newslettersForm.value;
      // Patch the form with the current values
      this.newslettersForm.patchValue(getform);
    } else {
      // Call the API method to fetch incubator names if the user is an Admin
      this.incubatorNameApi();
    }
  }

  /**
   * Handles the file selection event, sets the selected file name and sets the
   * uploadedFile variable to the selected file or null if no file is selected.
   * @param event - The event triggered when a file is selected.
   */
  onFileSelected(event: any) {
    this.uploadedFile = event.target.files[0] || null;
    // Set the selected file name
    if (this.uploadedFile) {
      this.selectedFileName = this.uploadedFile.name;
    } else {
      // Reset file details if no file is selected
      this.clearFileDetails();
    }
  }

  /**
   * Validates the uploaded file based on its type and clears the file details
   * if it is not a valid type.
   */
  onUpload() {
    if (this.uploadedFile) {
      const allowedTypes = ['.doc', '.pdf', '.webp'];
      const fileType = `.${this.uploadedFile.name.split('.').pop()}`;
      const isValidType = allowedTypes.includes(fileType);

      if (!isValidType) {
        // Clear the file details if the type is not valid
        this.clearFileDetails();
      }
    }
  }
  imageFile: any = [];
  /**
   * Retrieves the details of a newsletter from the server
   * based on the id.
   * @param id The id of the newsletter.
   */
  getNewsletterDetails(id) {
    /**
     * Make a get request to the newsletter api with the id.
     */
    this.makeapi.method(this.getApi + id, '', 'get').subscribe((data) => {
      /**
       * Patch the form values with the newsletter details.
       */
      this.newslettersForm.patchValue(data);
      /**
       * Set the image url and image file.
       */
      this.image_url = data.newsletterName;
      this.imageFile = data.newsletterFile;
    });
  }
  namePush = [];
  /**
   * Retrieves the list of incubators from the server.
   * The list of incubators is saved in the `incubatorNameList` property.
   * The `filterIncubetor` method is called to set the initial value of the
   * incubator name select.
   */
  incubatorNameApi() {
    this.makeapi.method(this.nameListApi, '', 'post').subscribe((data) => {
      // Save the list of incubators
      this.incubatorNameList = data;
      // Set the initial value of the incubator name select
      this.filterIncubetor();
    });
  }
  ImageValue: any = [];
  imgFormat: any;
  selecetdImage: File;
  imagetype: any;
  fileValue: File;
  url1: any = 'assets/images/upload.png';
  img_name = '';
  image_url: any = '';
  img: any;
  logoCheck = false;
  /**
   * Handles the image selection event.
   * If the image type is 'pdf', sets the image value, image name, and image URL.
   * If the image type is not 'pdf', shows an error message.
   * @param event - The event triggered when an image is selected.
   */
  onSelectImage(event) {
    this.image_url = '';
    this.imageFile = '';
    this.selecetdImage = event.target.files[0];
    if (event.target.files && this.selecetdImage) {
      const reader = new FileReader();
      const data = this.selecetdImage;
      this.imagetype = data.type;
      const imagedatatype = this.imagetype.split('/');
      const img_crt_type = imagedatatype[1];
      if (img_crt_type === 'pdf') {
        // If the image type is 'pdf', set the image value, image name, and image URL
        this.img = '';
        this.fileValue = this.selecetdImage;
        reader.readAsDataURL(this.fileValue);
        reader.onload = () => {
          this.url1 = reader.result;
          const spl = this.url1.split(',');
          this.ImageValue = spl[1];
          this.imageFile = spl[1];
          this.img_name = this.fileValue.name;
          this.logoCheck = false;
          this.uploadedFile = event.target.files[0] || null;
          // Set selected file name
          if (this.uploadedFile) {
            this.selectedFileName = this.uploadedFile.name;
          } else {
            // Reset file details if no file is selected
            this.clearFileDetails();
          }
        };
      } else {
        // If the image type is not 'pdf', show an error message
        this.img = 'show';
        this.notify.notifyError('Only *pdf formats are allowed');
      }
    }
  }
  /**
   * Handles the save event.
   * If the form is invalid or the image is not selected, shows an error message.
   * Otherwise, sends a POST request to the server to save the newsletters.
   */
  savenewsEvent() {
    let getform = this.newslettersForm.value;
    if (this.imageFile == '' || this.newslettersForm.invalid) {
      // If the form is invalid, mark all fields as touched
      this.newslettersForm.markAllAsTouched();
      if (this.imageFile == '') {
        // If the image is not selected, show an error message
        this.logoCheck = true;
      }
      // Show an error message
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      if (this.ImageValue != '') {
        // If the image is selected, set the image name and the image file
        getform.newsletterName = this.img_name;
        getform.newsletterFile = this.ImageValue;
      }
      // Send a POST request to the server to save the newsletters
      this.makeapi.method(this.saveApi, getform, 'post').subscribe((data) => {
        if (data.responseStatus === 'Success') {
          // If the request is successful, show a success message and close the dialog
          this.notify.notifysuccess(data.responseMessage);
          this.cancelEvent();
        } else {
          // If the request is not successful, show an error message
          this.notify.notifyError(data.responseMessage);
        }
      });
    }
  }
  /**
   * Cancels the current operation.
   * Resets the newsletters form and closes the dialog.
   */
  cancelEvent() {
    // Reset the form fields to their initial values
    this.newslettersForm.reset();
    // Close the dialog box
    this.dialogRef.close();
  }

  protected _onDestroy = new Subject();
  /**
   * Sets the initial value of the incubator select control and filters the list
   * of incubators based on the user's input.
   * Subscribes to the value changes of the filter control and calls the
   * filterBanks function whenever the value changes.
   */
  filterIncubetor() {
    // Set the default value of the incubator select control to the first element in the list
    this.incubatorName.setValue(this.incubatorNameList[1]);

    // Set the initial value of the incubator list
    this.incubatorListValue.next(this.incubatorNameList.slice());

    // Subscribe to the value changes of the filter control
    // When the value changes, call the filterBanks function
    this.incubatorFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterBanks();
      });
  }
  /**
   * Cleans up the component by unsubscribing from the onDestroy observable.
   * This prevents memory leaks when the component is destroyed.
   */
  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
  /**
   * Sets the initial value of the incubator select control.
   * Subscribes to the first value of the incubator list value and sets the compareWith
   * function of the singleSelect control to compare the incubator name strings.
   */
  protected setInitialValue() {
    this.incubatorListValue
      .pipe(
        // Take the first value of the incubator list value
        take(1),
        // Automatically unsubscribe on component destroy
        takeUntil(this._onDestroy)
      )
      .subscribe(() => {
        // Compare the incubator name strings
        this.singleSelect.compareWith = (a: incub, b: incub) =>
          a && b && a.incubatorName === b.incubatorName;
      });
  }
  /**
   * Filters the incubator names based on the search term from the filter control.
   * If no search term is provided, returns the full list of incubator names.
   */
  protected filterBanks() {
    // Check if the incubator name list is available
    if (!this.incubatorNameList) {
      return;
    }

    // Get the current search term from the filter control
    let search = this.incubatorFilterCtrl.value;

    if (!search) {
      // If no search term is provided, return the full list of incubator names
      this.incubatorListValue.next(this.incubatorNameList.slice());
      return;
    } else {
      // Convert the search term to lowercase for case-insensitive comparison
      search = search.toLowerCase();
    }

    // Filter the incubator name list based on the search term and update the list value
    this.incubatorListValue.next(
      this.incubatorNameList.filter(
        (val) => val.incubatorName.toLowerCase().indexOf(search) > -1
      )
    );
  }
  /**
   * Clears the file details.
   */
  private clearFileDetails(): void {
    this.uploadedFile = null;
    this.selectedFileName = null;
  }
}
